// react
import { useEffect, useState } from 'react';

// types
import { LoadingStatus } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormAddNonCashBenefit } from '../../forms/FormAddNonCashBenefit/FormAddNonCashBenefit';

// props
export interface DialogAddNonCashBenefitProps {
	DialogActionsProps?: Partial<DialogActionsProps>;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogAddNonCashBenefit = ({
	DialogActionsProps = {},
	isOpen,
	onClose,
	onSuccess,
}: DialogAddNonCashBenefitProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [status, setStatus] = useState<LoadingStatus>('LOADING');

	if (['DEFAULT', 'LOADING'].includes(status)) {
		DialogActionsProps.actions = [
			{
				children: t('cancel'),
				onClick: onClose,
			},
			{
				children: t('recordNonCashBenefit'),
				form: 'form-add-non-cash-benefit',
				loading: status === 'LOADING',
				type: 'submit',
				variant: 'contained',
			},
		];
	}

	DialogActionsProps.title = {
		children: t('recordNonCashBenefit'),
		variant: 'h3',
	};

	if (status === 'SUCCESS') {
		DialogActionsProps.actions = [
			{
				children: t('done'),
				onClick: onClose,
				variant: 'contained',
			},
		];
	}

	// reset status when dialog is closed
	useEffect(() => {
		if (!isOpen) {
			setStatus('DEFAULT');
		}
	}, [isOpen]);

	return (
		<DialogActions hasClose={true} isOpen={isOpen} onClose={onClose} {...DialogActionsProps}>
			<FormAddNonCashBenefit onSuccess={onSuccess} setStatus={setStatus} status={status} />
		</DialogActions>
	);
};
